import type { Settlement } from '../types';

export function getPopulationCount(settlement: Settlement): number {
    return settlement.people.length;
}

export function getHouseOccupants(settlement: Settlement): number[] {
    if (!settlement.houses || settlement.houses.length === 0) return [];
    return settlement.houses.map((house) => house.people.length);
}

export function getAssignedPopulation(settlement: Settlement): number {
    return settlement.people.reduce((sum, person) => (person.job ? sum + 1 : sum), 0);
}

export function getFreePopulation(settlement: Settlement): number {
    return settlement.people.reduce((sum, person) => (!person.job ? sum + 1 : sum), 0);
}
